import { styled } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { colors } from "@zapalacorp/tokens";

export const CommentCount = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  textAlign: "left",
  color: colors.blue500,
  cursor: "pointer",
  width: "fit-content",
}));

const styles = makeStyles(() => ({
  paper: {
    width: "560px !important",
  },
  body: {
    width: "100%",
  },
}));

export default styles;
